<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-contract-org-name" class="control-label">{{ inputLabel }}</label>
    <input
      v-model="inputValue"
      :disabled="disabled"
      id="form-contract-org-name"
      type="text"
      placeholder="Введите наименование организации"
      autocomplete="off"
      class="form-control"
      @change="emit"
      @input="emit"
      @blur="emit"
      @keyup.enter="emit"
      @keyup.delete="emit"
    />
    <typeahead
      v-model="inputValue"
      :async-function="typeahead"
      :data="typeaheadData"
      :item-key="typeaheadItemKey"
      :limit="typeaheadLimit"
      target="#form-contract-org-name"
      @input="selectTypeahead"
    >
      <template v-slot:item="props">
        <li
          v-for="(item, index) in props.items"
          :key="index"
          :class="{ active: props.activeIndex === index }"
        >
          <a role="button" @click="props.select(item)">
            <div v-html="props.highlight(item)"></div>
            <template v-if="item">
              <div>{{ item.inn }}</div>
              <div v-if="item.address">{{ item.address }}</div>
            </template>
          </a>
        </li>
      </template>
    </typeahead>
    <div v-if="!isView && terminalOrganizations.length > 0">
      <div
        v-for="(terminalOrganization, index) in terminalOrganizations"
        :key="index"
        class="overflow-ellipsis-text"
      >
        <a class="transport-owner-helpers" @click="$emit('change-contract-organization', terminalOrganization)">
          {{ terminalOrganization.name }}
        </a>
      </div>
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'
import mainMixin from '@/common/mixins/mainMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'ContractOrgNameInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin,
    mainMixin
  ],

  props: {
    inputLabel: {
      default: 'Организация, с которой заключен договор'
    },

    inputName: {
      default: 'contract_org_name'
    },

    inputHint: {
      default: undefined
    },

    terminalOrganizations: {
      type: Array,
      default: () => []
    }
  }
}
</script>
